module.exports = __webpack_public_path__ + "img/nature-51.3a864388.jpg";